import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import AudienceViewInfo from './audiences/AudienceViewInfo';
import { ICON_CANCEL } from './extras/icons';
//Redux
import { getAudiencesAction } from '../actions/audiencesActions';
import MainContent from './layout/MainContent';
//Función principal
const AudienceView = () => {
    //Tomo los parametros
    const { id } = useParams();
    //Tomo el history
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const audience = useSelector(state => state.audiences.audienceWork);
    const loading = useSelector(state => state.audiences.audienceLoading);
    const authUser = useSelector(state => state.auth.user);
    //Tomo los datos al inicio
    useEffect(() => {
        //Tienen q haber datos de usuario
        if(authUser){
            //Busco datos de audiencia
            dispatch( getAudiencesAction(id, authUser) );
        }
    }, [id, authUser]);
    //Nodos
    const nodes = [];
    //Acciones
    let actions = [
        {
            icon: <ICON_CANCEL />,
            text: 'CERRAR',
            link: `/audiencias`,
            css: 'danger',
            granted: true
        }
    ];
    //Renderizo
    return (
        <MainContent 
            title={`Audiencia #${id}`}
            subtitle={ audience && audience.estado ? audience.estado.descripcion : '' } 
            showSubtitle={true}
            cssSubtitle={`text-${audience && audience.estado ? audience.estado.css : 'gray'}`}
            nodes={nodes}
            actions={actions}
            component={ AudienceViewInfo }
        />
    );
};

export default AudienceView;